import { criarExecutor } from '@/uteis/action/estrutura/executor'
import { criarEstruturaInativa } from '@/uteis/action/estrutura/estruturaInativa'

export const criarInativacao = (estrutura, dadosSessao) => {
  var inativacao = {
    executor: criarExecutor(dadosSessao),
    participante: criarEstruturaInativa(estrutura),
    data: new Date().getTime(),
    atributos: {
      dataExclusao: estrutura.dataAlteracao,
      nomeGestor: estrutura.nomeUsuario
    }
  }

  return inativacao
}
